/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateConditionsRequestCompaniesInner
 */
export interface UpdateConditionsRequestCompaniesInner {
    /**
     * サービス種別
     * @type {number}
     * @memberof UpdateConditionsRequestCompaniesInner
     */
    serviceCategory: UpdateConditionsRequestCompaniesInnerServiceCategoryEnum;
    /**
     * 会社ID
     * @type {string}
     * @memberof UpdateConditionsRequestCompaniesInner
     */
    companyId: string;
    /**
     * 経済条件ID（紐付け解除の場合はnull）
     * @type {number}
     * @memberof UpdateConditionsRequestCompaniesInner
     */
    conditionId?: number | null;
}


/**
 * @export
 */
export const UpdateConditionsRequestCompaniesInnerServiceCategoryEnum = {
    OVERSEAS_ROAMING: 0
} as const;
export type UpdateConditionsRequestCompaniesInnerServiceCategoryEnum = typeof UpdateConditionsRequestCompaniesInnerServiceCategoryEnum[keyof typeof UpdateConditionsRequestCompaniesInnerServiceCategoryEnum];


/**
 * Check if a given object implements the UpdateConditionsRequestCompaniesInner interface.
 */
export function instanceOfUpdateConditionsRequestCompaniesInner(value: object): value is UpdateConditionsRequestCompaniesInner {
    if (!('serviceCategory' in value) || value['serviceCategory'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    return true;
}

export function UpdateConditionsRequestCompaniesInnerFromJSON(json: any): UpdateConditionsRequestCompaniesInner {
    return UpdateConditionsRequestCompaniesInnerFromJSONTyped(json, false);
}

export function UpdateConditionsRequestCompaniesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateConditionsRequestCompaniesInner {
    if (json == null) {
        return json;
    }
    return {
        
        'serviceCategory': json['service_category'],
        'companyId': json['company_id'],
        'conditionId': json['condition_id'] == null ? undefined : json['condition_id'],
    };
}

export function UpdateConditionsRequestCompaniesInnerToJSON(json: any): UpdateConditionsRequestCompaniesInner {
    return UpdateConditionsRequestCompaniesInnerToJSONTyped(json, false);
}

export function UpdateConditionsRequestCompaniesInnerToJSONTyped(value?: UpdateConditionsRequestCompaniesInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'service_category': value['serviceCategory'],
        'company_id': value['companyId'],
        'condition_id': value['conditionId'],
    };
}

